module.exports = __webpack_public_path__ + "img/avatar0.5466d987.png";